import React from "react";
import styles from "./Team.module.scss";
import AvatarCard from "../../components/avatarCard/AvatarCard";
import gdscTeam from "../../gdsc.json";
import { useColorModeValue } from "../../hooks/useColorModeValue";
const teamData = gdscTeam;

const Team = () => {
  return (
    <div className="layout-content">
      <div className={styles["container"]}>
        {Object.keys(teamData).map((domain, i) => {
          return <Domains key={i} domainData={teamData[domain]} domainName={domain} />;
        })}
      </div>
    </div>
  );
};

function Domains({ domainData, domainName }) {
  return (
    <>
      <div className={styles["heading"]}>
        <h1 style={{ color: useColorModeValue("#3F3F3F", "#ffffff") }}>{domainName}</h1>
      </div>
      <div className={styles["content"]}>
        {domainData.map((data) => {
          return <AvatarCard key={data.id} {...data}></AvatarCard>;
        })}
      </div>
    </>
  );
}

export default Team;
